import React from 'react'
import { Image } from '@chakra-ui/react'

import recom_4 from './assets/recom.-4.png'
import recom_3 from './assets/recom.-3.png'
import recom_2 from './assets/recom.-2.png'
import recom_1 from './assets/recom.-1.png'
import recom0 from './assets/recom.0.png'
import recom1 from './assets/recom.1.png'
import recom2 from './assets/recom.2.png'
import recom3 from './assets/recom.3.png'
import recom4 from './assets/recom.4.png'
import recom5 from './assets/recom.5.png'

const Icons = {
  '-4': recom_4,
  '-3': recom_3,
  '-2': recom_2,
  '-1': recom_1,
  '0': recom0,
  '1': recom1,
  '2': recom2,
  '3': recom3,
  '4': recom4,
  '5': recom5
}

export const getRecommendationIcon = score => Icons[score]

export const RecommendationIcon = ({ text, score, ...props }) => (
  <Image boxSize='50px' objectFit='cover' src={Icons[score]} alt={text} />
)

export default RecommendationIcon
